import { Injectable, Type } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { FullscreenData, isFullscreenableProperty } from '../_interfaces/fullscreen';
import { FeedbackService } from './feedback.service';

@Injectable({
  providedIn: 'root'
})
export class FullscreenService {

  private _modalFullscreenObserver: BehaviorSubject<FullscreenData> = new BehaviorSubject<FullscreenData>(null)

  constructor(
    private feedback: FeedbackService,
    private modalCtrl: ModalController
  ) { }



  public get modalFullscreenChange(): Observable<FullscreenData>{
    return this._modalFullscreenObserver.asObservable()
  }

  public get isFullScreenOnTicket(): boolean{
    return this._modalFullscreenObserver.value?.isOpen
  }


  /**
   * Öffnet instance in Fullscreen oder schießt diese wider je nach status von isFullscreen
   * @param {Type<any>} component  Klasse der Instance 
   * @param {any} instance example: self
   * @returns 
   */
  public async openModalInFullscreen(component: Type<any>, instance: any){
    let keyList: string[] = []

    //alle holen die einen Fullscreen Decorator haben
    Reflect.ownKeys(instance).forEach((key: string)=>{
      if(isFullscreenableProperty(instance, key)) keyList.push(key)
    })
    const data: any = keyList.reduce((a, v) => ({...a, [v]: instance[v]}), {})
    if(instance.isFullscreen){
      this._modalFullscreenObserver.next({isOpen: false})
      await this.feedback.openModal(component, data)
      return
    }
    this._modalFullscreenObserver.next({isOpen: true, componentType: component, instance: instance, data})
    await this.modalCtrl.dismiss()
  }

  /**
   * Schließt den Fullscreen
   */
  public closeFullscreen(){
    if(!this._modalFullscreenObserver.value?.isOpen) return
    this._modalFullscreenObserver.next({isOpen: false})
  }


}
